(function () {
  'use strict';

  // ISO 3166-1 alpha-2 to continent mapping
  var ISO_REGION = {
    // Africa
    DZ: 'Africa', EG: 'Africa', LY: 'Africa', MA: 'Africa', TN: 'Africa', SD: 'Africa', SS: 'Africa',
    BJ: 'Africa', BF: 'Africa', CV: 'Africa', GM: 'Africa', GH: 'Africa', GN: 'Africa', GW: 'Africa',
    CI: 'Africa', LR: 'Africa', ML: 'Africa', MR: 'Africa', NE: 'Africa', NG: 'Africa', SN: 'Africa',
    SL: 'Africa', TG: 'Africa', AO: 'Africa', CM: 'Africa', CF: 'Africa', TD: 'Africa', CG: 'Africa',
    CD: 'Africa', GQ: 'Africa', GA: 'Africa', ST: 'Africa', BI: 'Africa', KM: 'Africa', DJ: 'Africa',
    ER: 'Africa', ET: 'Africa', KE: 'Africa', MG: 'Africa', MW: 'Africa', MU: 'Africa', MZ: 'Africa',
    RW: 'Africa', SC: 'Africa', SO: 'Africa', TZ: 'Africa', UG: 'Africa', ZM: 'Africa', ZW: 'Africa',
    BW: 'Africa', LS: 'Africa', NA: 'Africa', SZ: 'Africa', ZA: 'Africa',
    // America
    AG: 'America', BS: 'America', BB: 'America', BZ: 'America', CA: 'America', CR: 'America',
    CU: 'America', DM: 'America', DO: 'America', SV: 'America', GD: 'America', GT: 'America',
    HT: 'America', HN: 'America', JM: 'America', MX: 'America', NI: 'America', PA: 'America',
    KN: 'America', LC: 'America', VC: 'America', TT: 'America', US: 'America',
    AR: 'America', BO: 'America', BR: 'America', CL: 'America', CO: 'America', EC: 'America',
    GY: 'America', PY: 'America', PE: 'America', SR: 'America', UY: 'America', VE: 'America',
    // Asia
    AF: 'Asia', AM: 'Asia', AZ: 'Asia', BD: 'Asia', BT: 'Asia', BN: 'Asia', KH: 'Asia',
    CN: 'Asia', GE: 'Asia', IN: 'Asia', ID: 'Asia', JP: 'Asia', KZ: 'Asia', KG: 'Asia',
    LA: 'Asia', MY: 'Asia', MV: 'Asia', MN: 'Asia', MM: 'Asia', NP: 'Asia', KP: 'Asia',
    PK: 'Asia', PH: 'Asia', SG: 'Asia', KR: 'Asia', LK: 'Asia', TW: 'Asia', TJ: 'Asia',
    TH: 'Asia', TL: 'Asia', TM: 'Asia', UZ: 'Asia', VN: 'Asia',
    // Europe
    AL: 'Europe', AD: 'Europe', AT: 'Europe', BY: 'Europe', BE: 'Europe', BA: 'Europe',
    BG: 'Europe', HR: 'Europe', CZ: 'Europe', DK: 'Europe', EE: 'Europe', FI: 'Europe',
    FR: 'Europe', DE: 'Europe', GR: 'Europe', HU: 'Europe', IS: 'Europe', IE: 'Europe',
    IT: 'Europe', XK: 'Europe', LV: 'Europe', LI: 'Europe', LT: 'Europe', LU: 'Europe',
    MT: 'Europe', MD: 'Europe', MC: 'Europe', ME: 'Europe', NL: 'Europe', MK: 'Europe',
    NO: 'Europe', PL: 'Europe', PT: 'Europe', RO: 'Europe', RU: 'Europe', SM: 'Europe',
    RS: 'Europe', SK: 'Europe', SI: 'Europe', ES: 'Europe', SE: 'Europe', CH: 'Europe',
    UA: 'Europe', GB: 'Europe', VA: 'Europe',
    // Middle East
    BH: 'Middle East', IQ: 'Middle East', IR: 'Middle East', IL: 'Middle East',
    JO: 'Middle East', KW: 'Middle East', LB: 'Middle East', OM: 'Middle East',
    QA: 'Middle East', SA: 'Middle East', SY: 'Middle East', AE: 'Middle East',
    YE: 'Middle East', CY: 'Middle East',
    // Oceania
    AU: 'Oceania', FJ: 'Oceania', KI: 'Oceania', MH: 'Oceania', FM: 'Oceania',
    NR: 'Oceania', NZ: 'Oceania', PW: 'Oceania', PG: 'Oceania', WS: 'Oceania',
    SB: 'Oceania', TO: 'Oceania', TV: 'Oceania', VU: 'Oceania'
  };


  var FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // Shopify uses full BCP-47 locale codes but metafields often store the short ISO 639-1 form.
  // This map expands shorthand → the full code Shopify actually accepts for locale_code.
  // Prefix matching against data.languages is tried first; this map is the last-resort fallback.
  var LOCALE_EXPAND = {
    'zh': 'zh-CN',
    'pt': 'pt-BR'
  };

  // Endonym display names for languages that may not appear in data.languages (e.g. when a
  // language is only enabled for specific markets, not globally published to the current visitor).
  var LANGUAGE_NAMES = {
    'ar': 'العربية',
    'zh': '中文',
    'fr': 'Français',
    'de': 'Deutsch',
    'es': 'Español',
    'it': 'Italiano',
    'ja': '日本語',
    'ko': '한국어',
    'pt': 'Português',
    'ru': 'Русский',
    'tr': 'Türkçe',
    'nl': 'Nederlands',
    'pl': 'Polski',
    'sv': 'Svenska',
    'da': 'Dansk',
    'nb': 'Norsk bokmål',
    'fi': 'Suomi',
    'he': 'עברית',
    'th': 'ภาษาไทย',
    'vi': 'Tiếng Việt',
    'id': 'Bahasa Indonesia',
    'ms': 'Bahasa Melayu'
  };

  var overlay, form, countryInput, localeInput, listEl;
  var data = {};
  var activeRegion = null;
  var onCloseCallback = null;

  function init() {
    var dataEl = document.getElementById('market-modal-data');
    if (!dataEl) return;

    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // Normalize marketLanguages: if the Shopify metafield is a multi_line_text_field type,
    // Liquid's | json filter double-encodes it as a string instead of an object.
    // Parse it here so downstream lookups (meta[c.market]) always work correctly.
    if (typeof data.marketLanguages === 'string') {
      try { data.marketLanguages = JSON.parse(data.marketLanguages); } catch (e) { data.marketLanguages = {}; }
    }
    if (!data.marketLanguages || typeof data.marketLanguages !== 'object') {
      data.marketLanguages = {};
    }

    // Debug: add ?debug_market=1 to the URL to inspect loaded data in the console
    if (window.location.search.indexOf('debug_market=1') !== -1) {
      console.log('[MarketModal] marketLanguages:', data.marketLanguages);
      console.table((data.countries || []).map(function (c) {
        var metaLangs = (data.marketLanguages || {})[c.market];
        return {
          iso: c.iso,
          name: c.name,
          market: c.market,
          shopifyLangs: (c.languages || []).join(', '),
          metafieldLangs: metaLangs ? metaLangs.join(', ') : '—'
        };
      }));
    }

    overlay = document.getElementById('market-modal-overlay');
    form = document.getElementById('market_modal_form');
    countryInput = document.getElementById('market_modal_country_code');
    localeInput = document.getElementById('market_modal_locale_code');
    listEl = document.getElementById('market-modal-list');

    if (!overlay || !form) return;

    // Trigger buttons (may be multiple — desktop + mobile)
    document.querySelectorAll('[data-market-modal-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(); });
    });

    overlay.querySelector('[data-market-modal-close]').addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', trapFocus);

    overlay.querySelectorAll('[data-region]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectRegion(btn.dataset.region, btn, null);
      });
    });

    // Header inline language switcher buttons (data-lang-switch="zh-CN" etc.)
    document.querySelectorAll('[data-lang-switch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var locale = btn.getAttribute('data-lang-switch');
        if (!countryInput || !localeInput || !form) return;
        countryInput.value = data.currentCountry;
        localeInput.value = locale;
        localeInput.disabled = false;
        localStorage.setItem('user_region_selected', data.currentCountry);
        form.submit();
      });
    });

    window.MarketModal = {
      open: openModal,
      close: closeModal,
      selectCountry: submitMarket
    };
  }

  // Replaces Liquid-rendered endonym names in the header language switcher with the correct display form:
  // Latin-script languages (en, fr, de…) → ISO code uppercased (EN, FR, DE)
  // Non-Latin script in LANGUAGE_NAMES (ar, zh…) → native endonym (العربية, 中文)
  function updateTriggerLangLabels() {
    document.querySelectorAll(
      '.market-switcher__lang[data-lang-iso],' +
      '.market-switcher__lang-btn[data-lang-iso]'
    ).forEach(function(el) {
      var iso = el.getAttribute('data-lang-iso');
      var shortIso = iso.slice(0, 2).toLowerCase();
      var nativeName = LANGUAGE_NAMES[iso] || LANGUAGE_NAMES[shortIso];
      el.textContent = nativeName || shortIso.toUpperCase();
    });
  }

  // options: { highlightCountry: 'AE', onClose: fn }
  function openModal(options) {
    options = options || {};
    onCloseCallback = options.onClose || null;

    overlay.hidden = false;
    document.body.classList.add('market-modal--open');

    // targetIso drives which region tab opens and the scroll target.
    // highlightIso (is-suggested + tick) is only set for geo-detected countries,
    // never for the current country — otherwise every other entry for the same
    // country (e.g. Belgium English/French when on Belgium Deutsch) gets a tick.
    var targetIso    = options.highlightCountry || data.currentCountry;
    var highlightIso = options.highlightCountry || null;
    var region = getRegion(targetIso);

    var regionBtn = region
      ? overlay.querySelector('[data-region="' + region + '"]')
      : null;

    if (regionBtn) {
      selectRegion(region, regionBtn, highlightIso);
    } else {
      selectFirstRegion();
    }

    requestAnimationFrame(function () {
      var first = overlay.querySelector(FOCUSABLE);
      if (first) first.focus();
    });
  }

  function closeModal() {
    overlay.hidden = true;
    document.body.classList.remove('market-modal--open');

    if (typeof onCloseCallback === 'function') {
      onCloseCallback();
      onCloseCallback = null;
    }

    var trigger = document.querySelector('[data-market-modal-trigger]');
    if (trigger) trigger.focus();
  }

  function trapFocus(e) {
    if (overlay.hidden) return;

    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;

    var focusable = Array.from(overlay.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (focusable.length < 2) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function getRegion(iso) {
    return iso ? (ISO_REGION[iso] || 'Other') : null;
  }

  function selectFirstRegion() {
    var btns = overlay.querySelectorAll('[data-region]');
    for (var i = 0; i < btns.length; i++) {
      var r = btns[i].dataset.region;
      if (countriesForRegion(r).length) {
        selectRegion(r, btns[i], null);
        return;
      }
    }
  }

  function selectRegion(region, btn, highlightIso) {
    activeRegion = region;

    overlay.querySelectorAll('[data-region]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });

    renderCountries(region, highlightIso);

    // Scroll the active region tab into view (needed on mobile horizontal scroll)
    requestAnimationFrame(function () {
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
  }

  function countriesForRegion(region) {
    return (data.countries || []).filter(function (c) {
      return getRegion(c.iso) === region;
    });
  }

  function resolveCountryLangs(c) {
    // c.languages is now populated server-side from market_languages metafield via bracket
    // notation lookup in market-modal.liquid — reliable for every market, not just current.
    if (c.languages && c.languages.length > 1) {
      return c.languages;
    }
    // JS-side fallback: reads the same metafield data from the marketLanguages object.
    // Handles edge cases where the server-side injection failed (e.g. multi_line_text_field type).
    var meta = data.marketLanguages || {};
    if (c.market && meta[c.market] && meta[c.market].length > 1) {
      return meta[c.market];
    }
    return null;
  }

  function buildEntries(countries) {
    var entries = [];

    countries.forEach(function (c) {
      var langs = resolveCountryLangs(c);
      if (langs) {
        langs.forEach(function (langIso) {
          // 1. Exact match against current market's published languages.
          // 2. Prefix match: "zh" matches "zh-CN" when visitor is already in that market.
          // 3. LOCALE_EXPAND fallback: handles visitors in other markets where data.languages
          //    won't contain the target language (e.g. US visitor selecting Chinese).
          var lang = (data.languages || []).find(function (l) { return l.iso === langIso; })
                  || (data.languages || []).find(function (l) { return l.iso.startsWith(langIso + '-'); });
          var resolvedIso = lang ? lang.iso : (LOCALE_EXPAND[langIso] || langIso);
          var resolvedName = lang ? lang.name : (LANGUAGE_NAMES[langIso] || langIso.toUpperCase());
          entries.push({ country: c, langIso: resolvedIso, langName: resolvedName });
        });
      } else {
        entries.push({ country: c, langIso: null, langName: null });
      }
    });

    entries.sort(function (a, b) {
      var na = a.country.name + (a.langName ? ' ' + a.langName : '');
      var nb = b.country.name + (b.langName ? ' ' + b.langName : '');
      return na.localeCompare(nb);
    });

    return entries;
  }

  function renderCountries(region, highlightIso) {
    if (!listEl) return;
    listEl.innerHTML = '';

    var entries = buildEntries(countriesForRegion(region));

    if (!entries.length) {
      var empty = document.createElement('li');
      empty.className = 'market-modal__empty';
      empty.textContent = 'No markets available for this region.';
      listEl.appendChild(empty);
      return;
    }

    entries.forEach(function (entry) {
      var c = entry.country;
      var isCurrent = c.iso === data.currentCountry &&
        (!c.market || c.market === data.currentMarketHandle) &&
        (!entry.langIso || entry.langIso === data.currentLocale);
      var isSuggested = !isCurrent && c.iso === highlightIso;

      var displayName = c.name;
      if (entry.langName) displayName += ' (' + entry.langName + ')';

      var li = document.createElement('li');
      li.className = 'market-modal__market-item' +
        (isCurrent ? ' is-current' : '') +
        (isSuggested ? ' is-suggested' : '');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'market-modal__market-btn no-hover';
      if (isCurrent) btn.setAttribute('aria-current', 'true');
      if (isCurrent) btn.setAttribute('disabled', '');

      var nameEl = document.createElement('span');
      nameEl.className = 'market-modal__market-name';
      nameEl.textContent = displayName;

      var currEl = document.createElement('span');
      currEl.className = 'market-modal__market-currency';
      currEl.textContent = c.currency + ' ' + c.symbol;

      btn.appendChild(nameEl);
      btn.appendChild(currEl);
      li.appendChild(btn);
      listEl.appendChild(li);

      if (!isCurrent) {
        btn.addEventListener('click', function () {
          showConfirm(c.iso, entry.langIso, displayName);
        });
      }
    });

    // Scroll to the suggested (geo-detected) country, or the current one as fallback
    requestAnimationFrame(function () {
      var target = listEl.querySelector('.is-suggested') || listEl.querySelector('.is-current');
      if (target) target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  // ── Confirmation dialog ───────────────────────────────────────────────────

  function showConfirm(countryIso, langIso, displayName) {
    var existing = document.getElementById('market-confirm-overlay');
    if (existing) existing.parentNode.removeChild(existing);

    var overlayEl = document.createElement('div');
    overlayEl.id = 'market-confirm-overlay';
    overlayEl.className = 'market-confirm__overlay';

    var dialog = document.createElement('div');
    dialog.id = 'geo-suggest-modal'; // Use styles from geo-switcher.css
    dialog.className = 'market-confirm__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.id = 'geo-suggest-close';
    closeBtn.className = 'no-hover';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="1.5" width="16" height="16" aria-hidden="true">' +
      '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    // Header
    var header = document.createElement('div');
    header.id = 'geo-suggest-header';
    var heading = document.createElement('h2');
    heading.id = 'geo-suggest-heading';
    heading.textContent = 'Welcome';
    header.appendChild(heading);

    var shopName = data.shopName || '';
    var boutiqueName = shopName ? shopName + ' boutique' : 'our boutique';
    var subheading = document.createElement('p');
    subheading.id = 'geo-suggest-subheading';
    subheading.innerHTML =
      'You are switching to the ' + escStr(boutiqueName) + ' for <strong>' + escStr(displayName) + '</strong>.';
    header.appendChild(subheading);

    // Body
    var body = document.createElement('div');
    body.id = 'geo-suggest-body';

    // Curation note
    var note1 = document.createElement('p');
    note1.className = 'geo-suggest-note';
    note1.textContent =
      'Each boutique is curated by country to provide precise pricing, taxes, and delivery services.';

    // Cart/wishlist note
    var note2 = document.createElement('p');
    note2.className = 'geo-suggest-note';
    note2.textContent = 'Your Cart and Wishlist will adjust accordingly.';

    // CTAs
    var actions = document.createElement('div');
    actions.className = 'geo-suggest-actions';

    var okBtn = document.createElement('button');
    okBtn.id = 'geo-suggest-confirm';
    okBtn.className = 'no-hover';
    okBtn.textContent = 'Continue';

    var cancelBtn = document.createElement('button');
    cancelBtn.id = 'geo-suggest-stay';
    cancelBtn.className = 'no-hover';
    var currentCountryObj = data.countries.find(function (c) { return c.iso === data.currentCountry; });
    var currentName = currentCountryObj ? currentCountryObj.name : data.currentCountry;
    if (currentCountryObj && resolveCountryLangs(currentCountryObj)) {
      var currentLangObj = (data.languages || []).find(function (l) { return l.iso === data.currentLocale; });
      if (currentLangObj) currentName += ' (' + currentLangObj.name + ')';
    }
    cancelBtn.textContent = 'Stay in ' + currentName;

    actions.appendChild(okBtn);
    actions.appendChild(cancelBtn);
    body.appendChild(note1);
    body.appendChild(note2);
    body.appendChild(actions);

    dialog.appendChild(closeBtn);
    dialog.appendChild(header);
    dialog.appendChild(body);
    overlayEl.appendChild(dialog);
    document.body.appendChild(overlayEl);

    requestAnimationFrame(function () { okBtn.focus(); });

    function closeConfirm() {
      if (overlayEl.parentNode) overlayEl.parentNode.removeChild(overlayEl);
    }

    okBtn.addEventListener('click', function () {
      closeConfirm();
      submitMarket(countryIso, langIso);
    });

    cancelBtn.addEventListener('click', closeConfirm);
    closeBtn.addEventListener('click', closeConfirm);

    overlayEl.addEventListener('click', function (e) {
      if (e.target === overlayEl) closeConfirm();
    });

    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') {
        closeConfirm();
        document.removeEventListener('keydown', onEsc);
      }
    });
  }

  function escStr(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ── Market form submit ────────────────────────────────────────────────────

  function submitMarket(countryIso, langIso) {
    countryInput.value = countryIso;

    var targetLang = langIso;
    if (!targetLang) {
      var countryObj = (data.countries || []).find(function (c) { return c.iso === countryIso; });
      if (countryObj) {
        if (countryObj.defaultLang) {
          targetLang = countryObj.defaultLang;
        } else if (countryObj.market) {
          var meta = data.marketLanguages || {};
          if (meta[countryObj.market] && meta[countryObj.market].length) {
            targetLang = meta[countryObj.market][0];
          }
        }
      }
    }

    if (targetLang) {
      localeInput.value = targetLang;
      localeInput.disabled = false;
    } else {
      // Omit locale_code so Shopify resets to the target market's primary language.
      // Submitting locale_code='' keeps the current locale (e.g. Arabic carries over to India).
      localeInput.disabled = true;
    }

    localStorage.setItem('user_region_selected', countryIso);
    form.submit();
  }

  // updateTriggerLangLabels runs unconditionally — independent of modal availability.
  // init() may return early on pages where the modal overlay isn't rendered, but the
  // header language switcher can still appear; this ensures it always gets resolved.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', updateTriggerLangLabels);
  } else {
    init();
    updateTriggerLangLabels();
  }

})();
